import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';
import BankMarchantsCategoryFormMeta from '../marchants/BankMarchantsCategoryFormHandler/BankMarchantsCategoryFormMeta';

export interface IBankSolvabilityLevelFormMeta {
  bankId: FormInputMeta,
  socialReason: FormInputMeta,

  // Schema
  schema: any,
}

const BankSolvabilityLevelFormMeta: IBankSolvabilityLevelFormMeta = { ...JSON.parse(JSON.stringify(BankMarchantsCategoryFormMeta))} as IBankSolvabilityLevelFormMeta

// BankContratTypeFormMeta.bankId = {
//   name: 'bankId',
//   type: 'text',
//   label: 'ID Banque',
//   placeholder: 'ID Banque',
//   validation: yup.string().required(),
// };

// BankContratTypeFormMeta.socialReason = {
//   name: 'socialReason',
//   type: 'text',
//   label: 'Raison Sociale',
//   placeholder: 'Raison Sociale',
//   validation: yup.string().required(),
// };

const validationSchama = getValidationSchema(BankSolvabilityLevelFormMeta);

BankSolvabilityLevelFormMeta.schema = yup.object().shape(validationSchama);

export default BankSolvabilityLevelFormMeta;